import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Building2, Activity } from "lucide-react";

const InstitutionalPage = () => {
  return (
    <div className="min-h-screen bg-slate-950 p-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 bg-gradient-to-br from-amber-500 to-orange-600 rounded-lg flex items-center justify-center">
            <Building2 className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-white">Institutional</h1>
            <p className="text-slate-400 text-sm">Institutional investor activity</p>
          </div>
        </div>
        
        <Card className="bg-slate-900 border-slate-800">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2">
              <Activity className="w-5 h-5 text-amber-400" />
              Coming Soon
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-slate-400">
              This page will track institutional holdings, 13F filings, 
              hedge fund positions, and smart money movements.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default InstitutionalPage;
